export const sendLogToLoki = async (
  message: string,
  code: number,
  type: "error" | "info" | "debug",
  api_endpoint: string
) => {
  const timestamp = Date.now() * 1_000_000;
  const lokiObj = {
    message: message,
    timestamp: new Date().toISOString(),
  };
  const logEntry = JSON.stringify(lokiObj);
  const payload = {
    streams: [
      {
        stream: {
          api_endpoint,
          job: `sdap-fe-${process.env.REACT_APP_ENVIRONMENT}`,
          level: type,
          code,
          source: `sdap-fe-${process.env.REACT_APP_ENVIRONMENT}`,
          path_name: window.location.pathname,
          url: window.location.href,
        },
        values: [[timestamp.toString(), logEntry]],
      },
    ],
  };

  const lokiEndpoint = process.env.REACT_APP_LOKI_ENDPOINT as string;
  await fetch(lokiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
};
